import { ITableData, IColumnDef } from '../table/types';

export function bubbleDataToTable(data: any): ITableData {
    const items: Array<{ label: string; value: number; [key: string]: any }> = data?.data ?? [];

    const columns: IColumnDef[] = [
        { header: 'Name', field: 'label', metric: 'label', type: 'dimension', metricType: 'text', sortable: true },
        { header: 'Value', field: 'value', metric: 'value', type: 'metric', metricType: 'number', sortable: true },
    ];

    const rows = items.map((item) => ({
        label: item.label,
        value: item.value,
    }));

    return {
        columns,
        rows,
        metadata: {},
    };
}

export function chartDataToTable(data: any, chartType: string): ITableData {
    switch (chartType) {
        case 'bubble':
            return bubbleDataToTable(data);
        case 'pie':
        case 'doughnut':
            return pieDataToTable(data);
        default:
            return genericChartDataToTable(data);
    }
}

function pieDataToTable(data: any): ITableData {
    const items: Array<{ name: string; value: number }> = data?.data ?? [];

    const columns: IColumnDef[] = [
        { header: 'Name', field: 'name', metric: 'name', type: 'dimension', metricType: 'text', sortable: true },
        { header: 'Value', field: 'value', metric: 'value', type: 'metric', metricType: 'number', sortable: true },
    ];

    const rows = items.map((item) => ({
        name: item.name,
        value: item.value,
    }));

    return { columns, rows, metadata: {} };
}

function genericChartDataToTable(data: any): ITableData {
    const items: any[] = data?.data ?? [];
    if (items.length === 0) return { columns: [], rows: [], metadata: {} };

    const keys = Object.keys(items[0]);
    const columns: IColumnDef[] = keys.map((key) => ({
        header: key,
        field: key,
        metric: key,
        type: key === 'segment' ? 'dimension' as const : 'metric' as const,
        metricType: typeof items[0][key] === 'number' ? 'number' as const : 'text' as const,
        sortable: true,
    }));

    return { columns, rows: items, metadata: {} };
}

